import React from 'react'
import { observer, inject } from 'mobx-react'
import LoadingComponent from '../../../LoadingComponent'
import { Link } from 'react-router'
import { append } from '../../../../utils/url'
import { formatDate } from '../../../../utils/format'
import Copy from './Copy'
import Icon from '../../../util/Icon'
import PostLink from '../../../util/PostLink'
import DropdownMenu from '../../../navigation/DropdownMenu'
import OrderableTH from '../../../navigation/OrderableTH'
import StorePagination from '../../../navigation/StorePagination'
import classnames from 'classnames'

@inject('websites', 'hotsheets')
@observer
export default class WebsiteHotsheets extends LoadingComponent {
  website = this.props.websites.current

  state = {
    search: '',
    order_by: 'hotsheets.created_at',
    order_dir: 'desc'
  }

  hasLoaded() {
    return this.props.hotsheets.loaded
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    this.props.hotsheets.loadPage(nextPage || page, this.state)
  }

  componentWillMount() {
    const { search='', order_by='hotsheets.created_at', order_dir='desc' } = this.props.location.query

    this.setState({ search, order_by, order_dir }, () => this.loadPage())
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  componentDidUpdate() {
    if (typeof(this.searchField) !== 'undefined') {
      this.searchField.focus()
    }
  }

  handleSearch = ({ target: { value:search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  deleteHandlerFor = hotsheet => event => {
    event.preventDefault()
    const confirmed = window.confirm(`Really delete the ${hotsheet.name} hotsheet?`)
    if (!confirmed) {
      return
    }
    this.props.hotsheets.delete(hotsheet.id)
  }

  renderLoaded() {
    const { search } = this.state
    const { state:{ highlight }={} } = this.props.location
    return (
      <div className="container padded hotsheets">
        <div className="panel full padded">
          <h2 className="title">Hotsheets</h2>
          <div className="table-actions">
            <input type="search" placeholder="Search Hotsheets..." title="Search by hotsheet name or description" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }} />
            <Link className="button" to={append('add')}>New Hotsheet</Link>
          </div>
          <div>
            <table className="zebra hotsheets-table">
              <thead>
                <tr>
                  <OrderableTH className="left" query={this.state} field="hotsheets.name">Name</OrderableTH>
                  <OrderableTH query={this.state} field="searches.title">Search</OrderableTH>
                  <th>Shortcode</th>
                  <OrderableTH query={this.state} field="hotsheets.created_at" defaultDesc>Created</OrderableTH>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="padded">
                {this.props.hotsheets.map(h => (
                  <tr key={h.id} className={classnames({ highlight: highlight === h.id })}>
                    <td>{h.name}</td>
                    <td className="center">{h.search_title}</td>
                    <td className="center">
                      {h.shortcode}
                      <Copy text={h.shortcode} />
                    </td>
                    <td className="center">{formatDate(h.created_at)}</td>
                    <td className="center">
                      <DropdownMenu menuClass="website-page-actions" menuTitle={<Icon icon="bars" />}>
                        <Link to={append(`edit/${h.id}`)}>Edit</Link>
                        <PostLink href={this.website.default_url} params={{ initial_search_filters: JSON.stringify(h.search_params) }} target="_blank">Preview Results</PostLink>
                        <a className="danger" href="#" onClick={this.deleteHandlerFor(h)}>Delete</a>
                      </DropdownMenu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <StorePagination store={this.props.hotsheets} query={this.state} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Hotsheets/index.js